export function createChatFilter(includePending = false) {
  return function ({ chat_type }: { chat_type: string }) {
    return chat_type === 'summary'
        || chat_type === 'summary_noanswer'
        || chat_type === 'summary_noanswer_notax'
        || chat_type === 'forbidden'
        || (includePending && chat_type === 'pending');
  }
}
